// https://explorer.metis.io/address/0x6fDaFb26915ABD6065a1E1501a37Ac438D877f70
export const CROSS_CHAIN_CONTROLLER = '0x6fDaFb26915ABD6065a1E1501a37Ac438D877f70';

// IPayloadsControllerCore https://explorer.metis.io/address/0x2233F8A66A728FBa6E1dC95570B25360D07D5524
export const PAYLOADS_CONTROLLER = '0x2233F8A66A728FBa6E1dC95570B25360D07D5524';

// https://explorer.metis.io/address/0x81d32B36380e6266e1BDd490eAC56cdB300afBe0
export const PC_DATA_HELPER = '0x81d32B36380e6266e1BDd490eAC56cdB300afBe0';

// https://explorer.metis.io/address/0x61BE97d3a0550549f67CA7421725fA73Fa2036B5
export const GRANULAR_GUARDIAN = '0x61BE97d3a0550549f67CA7421725fA73Fa2036B5';

// https://explorer.metis.io/address/0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe
export const GOVERNANCE_GUARDIAN = '0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe';

// https://explorer.metis.io/address/0x6fD45D32375d5aDB8D76275A3932c740F03a8718
export const EXECUTOR_LVL_1 = '0x6fD45D32375d5aDB8D76275A3932c740F03a8718';

export const CHAIN_ID = 1088;
